/**
 * Default application settings
 */
export default {
  // list of the available languages
  languages: ['en', 'de'], // null = all available languages, otherwise e.g. ['en', 'de']
  // list of available namespaces, will be concatenated with `defaultNamespaces`
  // from `lib/manager/intl/index.js`
  namespaces: [
    'admin',
    'ticket',
  ],
}
